<template>
  <div
    class="sf-virtual-table__data-row-cell tw-w-full"
    data-testid="sf-virtual-table-data-cell"
  >
    <slot />
  </div>
</template>

<script>
export default {}
</script>
<style lang="scss" scoped>
@import 'silverfin-ui-kit/src/scss/tooling';

.sf-virtual-table__data-row-cell {
  @include table-data-cell(
    (
      background-color: transparent,
    )
  );

  border-top-style: none;
  border-left-style: none;
}
</style>
